import React from 'react';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
dayjs.extend(weekOfYear);

const moods = [
  {
    name: 'Mercury Mayhem',
    emoji: '🔥',
    prediction: 'Expect some chaos. Bugs will align with QA. Stay nimble and double-check your PRs!'
  },
  {
    name: 'Venus Vibes',
    emoji: '💖',
    prediction: 'Collaboration is in the air. Pair programming will be extra harmonious. Spread the love (and code reviews)!'
  },
  {
    name: 'Saturn Structure',
    emoji: '🪐',
    prediction: 'Time to refactor! Structure and discipline will bring clarity to your codebase.'
  },
  {
    name: 'Jupiter Joy',
    emoji: '🎉',
    prediction: 'Big wins are coming! Celebrate small victories and share your progress with the team.'
  },
  {
    name: 'Neptune Naps',
    emoji: '😴',
    prediction: 'Rest is productive. Take breaks, hydrate, and let your subconscious solve the hard bugs.'
  },
  {
    name: 'Pluto Pivot',
    emoji: '🔄',
    prediction: 'Change is inevitable. Embrace new requirements and pivot with cosmic grace.'
  },
  {
    name: 'Solar Success',
    emoji: '🌞',
    prediction: 'The spotlight is on you! Shine bright and lead the sprint to new heights.'
  },
];

function getWeeklyMood() {
  const week = dayjs().week();
  return moods[week % moods.length];
}

function SprintMood() {
  const mood = getWeeklyMood();
  return (
    <section className="bg-white rounded-xl shadow p-6 flex flex-col items-center">
      <h1 className="text-3xl font-bold mb-2">{mood.name}</h1>
      <div className="text-6xl mb-2">{mood.emoji}</div>
      <p className="text-center text-gray-600">{mood.prediction}</p>
    </section>
  );
}

export default SprintMood; 